"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _AudioController = _interopRequireDefault(require("./AudioController"));

var _deepEqual = _interopRequireDefault(require("../../utils/object/deepEqual"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var AudioLayer = /*#__PURE__*/function () {
  function AudioLayer(audioCreativeLayer, audio) {
    (0, _classCallCheck2["default"])(this, AudioLayer);
    (0, _defineProperty2["default"])(this, "_audio", void 0);
    (0, _defineProperty2["default"])(this, "_creativeLayer", void 0);
    (0, _defineProperty2["default"])(this, "_elementId", void 0);
    (0, _defineProperty2["default"])(this, "_speed", 1);

    if (!_AudioController["default"].isAudioController(audio)) {
      throw new Error('Must provide valid webAudio');
    }

    this._elementId = audioCreativeLayer.elementId;
    this._creativeLayer = audioCreativeLayer;
    this._audio = audio;
  }

  (0, _createClass2["default"])(AudioLayer, [{
    key: "speed",
    get: function get() {
      return this._speed;
    },
    set: function set(value) {
      this._speed = value;
    }
  }, {
    key: "creativeLayer",
    get: function get() {
      return this._creativeLayer;
    },
    set: function set(value) {
      this._creativeLayer = value;
    }
  }, {
    key: "audio",
    get: function get() {
      return this._audio;
    },
    set: function set(value) {
      this._audio = value;
    }
  }], [{
    key: "isAudioLayer",
    value: function isAudioLayer(inputObject) {
      return inputObject instanceof AudioLayer;
    }
  }, {
    key: "isAudioLayerOutOfDate",
    value: function isAudioLayerOutOfDate(audioLayer, currentCreativeLayer) {
      if (!AudioLayer.isAudioLayer(audioLayer)) {
        throw new Error('Must provide a valid Audio Layer');
      }

      var audio = audioLayer.audio,
          creativeLayer = audioLayer.creativeLayer,
          speed = audioLayer.speed;
      if ((0, _isNil["default"])(audio)) return true;
      var hasSpeedChanged = audio.getPlaybackSpeed() !== speed;
      return !(0, _deepEqual["default"])(currentCreativeLayer, creativeLayer) || hasSpeedChanged;
    }
  }]);
  return AudioLayer;
}();

exports["default"] = AudioLayer;